import App from './App'
// import Hello from '@/components/Hello'
export default [
  {
    path: '/',
    component: App,
    children: [
      {
        path: '/main',
        meta: { keepAlive: false },
        component: require('./pg/main')
      },
      {
        path: '/',
        meta: { auth: false },
        component: resolve => require(['./pg/login/index'], resolve)
      },
      {
        path: '/evaluate',
        component: resolve => require(['./pg/order/evaluate'], resolve)
      },
      {
        path: '/oauth',
        meta: { auth: false },
        component: resolve => require(['./pg/login/oauth'], resolve)
      },
      {
        path: '/login',
        meta: { auth: false },
        component: resolve => require(['./pg/login/login'], resolve)
      },
      {
        path: '/confirm-info',
        meta: { auth: false },
        component: resolve => require(['./pg/login/confirm-info'], resolve)
      },
      {
        path: '/register',
        meta: { auth: false },
        component: resolve => require(['./pg/login/register'], resolve)
      },
      {
        path: '/bind-card',
        meta: { auth: false },
        component: resolve => require(['./pg/login/bind-card'], resolve)
      },
      {
        path: '/new-creat',
        meta: { auth: false },
        component: resolve => require(['./pg/login/new-creat'], resolve)
      },
      {
        path: '/card-new-creat',
        meta: { auth: false },
        component: resolve => require(['./pg/login/card-new-creat'], resolve)
      },
      {
        path: '/company-name',
        meta: { auth: false },
        component: resolve => require(['./pg/login/company-name'], resolve)
      },
      {
        path: '/personal-center',
        component: resolve => require(['./pg/personal/personal-center'], resolve)
      },
      {
        path: '/personal-info',
        component: resolve => require(['./pg/personal/personal-info'], resolve)
      },
      {
        path: '/quick-pay',
        component: resolve => require(['./pg/personal/quick-pay'], resolve)
      },
      {
        path: '/quick-pay-bill',
        component: resolve => require(['./pg/personal/quick-pay-bill'], resolve)
      },
      {
        path: '/binding-phone',
        component: resolve => require(['./pg/personal/binding-phone'], resolve)
      },
      {
        path: '/dish-statistics',
        component: resolve => require(['./pg/dish-statistics'], resolve)
      },
      {
        path: '/month-bill',
        component: require('./pg/month-bill')
      },
      {
        path: '/change-password',
        component: resolve => require(['./pg/personal/change-password'], resolve)
      },
      {
        path: '/order-detail',
        component: resolve => require(['./pg/order/order-detail'], resolve)
      },
      {
        path: '/period-list', // 餐段页(订餐首页)
        meta: { keepAlive: true },
        component: resolve => require(['./pg/period-list'], resolve)
      },
      {
        path: '/menu', // 菜单页
        component: resolve => require(['./pg/menu'], resolve)
      },
      {
        path: '/order-list',
        meta: { keepAlive: true },
        component: resolve => require(['./pg/order/order-list'], resolve)
      },
      {
        path: '/confirm-order',
        meta: { keepAlive: true },
        component: resolve => require(['./pg/order/confirm-order'], resolve)
      },
      {
        path: '/select-delivery-address',
        component: resolve => require(['./pg/order/select-delivery-address'], resolve)
      },
      {
        path: '/delivery-address-detail',
        component: resolve => require(['./pg/order/delivery-address-detail'], resolve)
      },
      {
        path: '/pay',
        component: resolve => require(['./pg/order/pay'], resolve)
      },
      {
        path: '/pay-success',
        component: resolve => require(['./pg/order/pay-success'], resolve)
      },
      {
        path: '/my-qr-code',
        component: require('./pg/my-qr-code')
      },
      {
        path: '/charge',
        component: require('./pg/order/recharge')
      },
      {
        path: '/a-month-bill',
        component: resolve => require(['./pg/a-month-bill'], resolve)
      },
      {
        path: '/recharge-detail',
        component: require('./pg/recharge-detail')
      },
      {
        path: '/open-register',
        meta: { auth: false },
        component: resolve => require(['./pg/login/open-register'], resolve)
      },
      {
        path: '/association',
        meta: { auth: false },
        component: resolve => require(['./pg/login/association'], resolve)
      },
      {
        path: '/association',
        meta: { auth: false },
        component: resolve => require(['./pg/login/association'], resolve)
      },
      {
        path: '/change-card',
        meta: { auth: false },
        component: resolve => require(['./pg/login/change-card'], resolve)
      },
      {
        path: '/verification-phone',
        meta: { auth: false },
        component: resolve => require(['./pg/login/verification-phone'], resolve)
      },
      {
        path: '/company-qr-code',
        meta: { auth: false },
        component: resolve => require(['./pg/personal/company-qr-code'], resolve)
      },
      {
        path: '/',
        meta: { auth: false },
        component: resolve => require(['./pg/login/login'], resolve)
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/routes.js